<template>
    <div v-if="isLoaded">
        <b-card>
            <div style="margin-bottom:10px">
                <b-row align-h="end">

                    <b-row style="margin-right:50%;" v-if="!this.gbId(this.$store.state.user.customerId) && canGetReport()">
                        <b-col>
                            <b-row>
                                <b-button @click="$refs.excelTypes.show()" size="lg" ><i class="far fa-file-excel"></i></b-button>
                            </b-row>
                        </b-col>
                        <b-row style="margin-left:10px; margin-top:15px"> {{$t('exportData')}} </b-row>
                        <b-modal ref="excelTypes" size="m" hide-footer hide-header centered>
                            <div class="d-block text-center">
                                <b-row align-h="start">
                                    <b-col style="font-weight: bold; text-align: left">
                                        {{$t('folder')}}
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1">
                                    <b-col>
                                        <b-form-select cols="6" v-model="selectedExcel.type" :options="excelTypes"></b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col>
                                        <div style="float:left;">
                                            <span><el-date-picker v-model="selectedExcel.startYear" type="year" format="yyyy" value-format="yyyy" :picker-options="startYearOption" @change="selectStartYear"/></span>
                                            <span>-</span>
                                            <span><el-date-picker v-model="selectedExcel.endYear" type="year" format="yyyy" value-format="yyyy" :picker-options="endYearOption" @change="selectEndYear"/></span>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col style="font-weight: bold; text-align: left">
                                        <b-form-select cols="6" v-model="selectedExcel.location" :options="locationTypes"></b-form-select>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row align-h="end">
                                <b-col cols="6">
                                    <b-btn size="sm" class="mt-3" variant="outline-primary" block @click="exportExcel()">{{$t('export')}}</b-btn>
                                </b-col>
                            </b-row>
                        </b-modal>
                    </b-row>
                    <year-select style="margin-right: 20px" @onchange="onYearChange"/>
                    <!-- <site-type-select v-if="siteTypes.length" style="margin-right: 20px" @onchange="onSiteTypeChange"/> -->
                    <region-multi-select
                        style="margin-right: 10px"
                        :selectedRegionId="selectedSiteGroupId"
                        :regions="siteGroups"
                        @oninput="selectSiteGroupId"/>
                    <site-multi-select
                        :selectedSiteId="selectedSiteId"
                        :givenSites="filteredSites"
                        @oninput="selectSiteId"
                    />
                </b-row>
            </div>
            <div class="scroll-content" style="overflow-x:hidden;">
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 20px">
                    <b-row align-h="end" no-gutters>
                        <div style="margin: 15px">
                        <span
                            class="card-nav"
                            :style="{color: activeTabs.firstBox === 'carbon' ? '#1c7430' : ''}"
                            @click="activeTabs.firstBox = 'carbon'">
                            {{$t('carbonEmission')}}
                        </span>
                            <span style="margin: 0 5px; color: #1c7430">|</span>
                            <span class="card-nav"
                                :style="{color: activeTabs.firstBox === 'consumption' ? '#1c7430' : ''}"
                                @click="activeTabs.firstBox = 'consumption'">
                            {{$t('carbonConsumption')}}
                        </span>
                        </div>
                    </b-row>
                    <b-row align-h="center" style="margin-top: 30px;">
                        <span style="font-size: 1.1em; font-weight: bold;">{{ activeTabs.firstBox === 'carbon' ? $t('carbonEmissionTitle') : $t('carbonConsumptionTitle') }}</span>
                    </b-row>
                    <total-carbon-emissions
                        v-if="activeTabs.firstBox === 'carbon'"
                        :initial-emissions="JSON.parse(JSON.stringify(emissions))"
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        :group-type="'scopeGroup'"
                        style="margin-top: 30px; min-height: 300px"/>
                    <total-carbon-consumptions v-else
                        :initial-consumptions="JSON.parse(JSON.stringify(consumptions))"
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        style="margin-top: 30px; min-height: 300px"/>
                </div>
                <total-waste-produced
                    :initial-waste="JSON.parse(JSON.stringify(waste))"
                    :selected-site-id="selectedSiteId"
                    :selected-site-group-id="selectedSiteGroupId"
                    style="margin-top: 30px"/>
                <intensity-measurements-of-emission
                    :initial-intensity-report="JSON.parse(JSON.stringify(intensityReport))"
                    :initial-emissions="JSON.parse(JSON.stringify(emissions))"
                    :selected-site-id="selectedSiteId"
                    :selected-site-group-id="selectedSiteGroupId"
                    style="margin-top: 30px"/>
                <scope-comparison
                    :initial-scope-report="JSON.parse(JSON.stringify(scopeReport))"
                    :initial-emissions="JSON.parse(JSON.stringify(emissions))"
                    :selected-site-id="selectedSiteId"
                    :selected-site-group-id="selectedSiteGroupId"
                />
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 30px">
                    <b-row align-h="center" style="margin-top: 30px;" no-gutters>
                        <span style="font-size: 1.1em; font-weight: bold;">{{ $t('Emissions Breakdown') }}</span>
                    </b-row>
                    <emission-distribution
                        :initial-emissions="JSON.parse(JSON.stringify(emissions))"
                        :selected-site-id="selectedSiteId"
                        :selected-site-group-id="selectedSiteGroupId"
                        style="margin-top: 30px"
                    />
                </div>
                <template v-if="this.$store.state.user.permissions.canViewComparisons">
                <div style="border: 1px solid rgba(135,135,136,0.3); margin-top: 30px" v-if="!selectedSiteId">
                    <b-row align-h="end" no-gutters>
                        <div style="margin: 15px">
                            <span
                                class="card-nav"
                                :style="{color: activeTabs.lastBox === 'emission' ? '#1c7430' : ''}"
                                @click="activeTabs.lastBox = 'emission'">
                                {{ $t('totalEmission') }}
                            </span>
                            <span style="margin: 0 5px; color: #1c7430">|</span>
                            <span class="card-nav"
                                :style="{color: activeTabs.lastBox === 'intensity' ? '#1c7430' : ''}"
                                @click="activeTabs.lastBox = 'intensity'">
                                {{ $t('carbonEmissionDensity') }}
                            </span>
                            <span style="margin: 0 5px; color: #1c7430">|</span>
                            <span class="card-nav"
                                :style="{color: activeTabs.lastBox === 'consumption' ? '#1c7430' : ''}"
                                @click="activeTabs.lastBox = 'consumption'">
                                {{$t('carbonConsumption')}}
                            </span>
                        </div>
                    </b-row>
                    
                    <b-row align-h="center" style="margin-top: 30px;" no-gutters>
                        <span style="font-size: 1.1em; font-weight: bold;">{{$t('performanceComparison')}}</span>
                    </b-row>
                    
                    <performance-comparing
                        v-if="!selectedSiteId"
                        :comparing-data="JSON.parse(JSON.stringify(comparingData || null))"
                        :type="activeTabs.lastBox"
                        :selected-site-group-id="selectedSiteGroupId"
                        style="margin-top: 30px"/>
                        </div>
                    </template>
                    <template v-else>
                    </template>
            </div>
        </b-card>
    </div>
    <div v-else></div>
</template>

<script>
import qs from 'qs';
import Multiselect from 'vue-multiselect';

import YearSelect from '../../../components/YearSelect';
import RegionMultiSelect from '../../../components/RegionMultiSelect';
import SiteMultiSelect from '../../../components/SiteMultiSelect';
import SiteTypeSelect from '../../../components/SiteTypeSelect';

import TotalCarbonEmissions from './components/TotalCarbonEmissions';
import TotalCarbonConsumptions from './components/TotalCarbonConsumptions';
import PerformanceComparing from './components/PerformanceComparing';
import EmissionDistribution from './components/EmissionDistribution';
import IntensityMeasurementsOfEmission from './components/IntensityMeasurementsOfEmission';
import ScopeComparison from './components/ScopeComparison';
import TotalWasteProduced from './components/TotalWasteProduced';

export default {
    components: {
        ScopeComparison,
        IntensityMeasurementsOfEmission,
        EmissionDistribution,
        PerformanceComparing,
        TotalCarbonConsumptions,
        TotalWasteProduced,
        SiteTypeSelect,
        SiteMultiSelect,
        RegionMultiSelect,
        YearSelect,
        Multiselect,
        TotalCarbonEmissions
    },
    name: 'analysis',
    data() {
        return {
            isLoaded: false,
            filteredSites: [],
            selectedSiteId: null,
            selectedSiteGroupId: null,
            selectedExcel : {
                type: null,
                startYear: '',
                endYear: '',
                location: null,
            },
            startYearOption: {},
            endYearOption: {},
            comparingData: [],
            emissions: {
                current: [],
                past: [],
                emissionTypes: []
            },
            consumptions: {
                currentConsumptions: [],
                pastConsumptions: []
            },
            waste: {
                currentWaste: [],
                pastWaste: []
            },
            intensityReport: {
                currentConsumptions: [],
                currentEmissions: [],
                currentStaffs: [],
                pastConsumptions: [],
                pastEmissions: [],
                pastStaffs: []
            },
            scopeReport: {
                current: [],
                past: [],
                tags: []
            },
            excelTypes: [
                {
                    value: null,
                    text: this.$t('chooseExcel'),
                    disabled: true
                },
                {
                    value: 1,
                    text: this.$t('totalGHGReport')
                },
                {
                    value: 2,
                    text: this.$t('totalConsumptionReport')
                }
            ],
            locationTypes: [
                {
                    value: null,
                    text: this.$t('chooseLocation'),
                    disabled: true
                },
                {
                    value: 1,
                    text: this.$t('allLocations'),
                },
                {
                    value: 2,
                    text: this.$t('regions')
                },
                {
                    value: 3,
                    text: this.$t('locationTypes')
                }
            ],
            activeTabs: {
                firstBox: 'carbon',
                lastBox: 'emission'
            },
            excelData: null
        };
    },

    methods: {
        exportExcel() {
            this.$refs.excelTypes.hide();

            if(this.selectedExcel.location == null){
                this.selectedExcel.location = 1
            }
            if(this.selectedExcel.startYear == null && this.selectedExcel.endYear != null){
                this.selectedExcel.startYear = this.selectedExcel.endYear;
            }
            if(this.selectedExcel.startYear != null && this.selectedExcel.endYear == null){
                this.selectedExcel.endYear = this.selectedExcel.startYear;
            }

            if(this.selectedExcel.startYear == null || this.selectedExcel.endYear == null || this.selectedExcel.type == null){
                return;
            }

            if (this.selectedExcel.type == 1) {
                window.open(`${this.apiURL}/totalGHGReportExport?startYear=${this.selectedExcel.startYear}&endYear=${this.selectedExcel.endYear}&locations=${this.selectedExcel.location}&locale=${this.$store.state.locale}&token=${this.downloadToken}`);
            } else if (this.selectedExcel.type == 2) {
                window.open(`${this.apiURL}/totalConsumptionReportExport?startYear=${this.selectedExcel.startYear}&endYear=${this.selectedExcel.endYear}&locations=${this.selectedExcel.location}&locale=${this.$store.state.locale}&token=${this.downloadToken}`);
            }
        },
        selectStartYear() {
            var start = new Date(this.selectedExcel.startYear, 0);

            this.endYearOption = {
                disabledDate: (time) => {
                    return time.getTime() < start;
                }
            };
            if(this.selectedExcel.endYear != ''){
                var end = new Date(this.selectedExcel.endYear, 0);

                if(start > end){
                    this.selectedExcel.endYear = this.selectedExcel.startYear;
                }
            }
        },
        selectEndYear() {
            var end = new Date(this.selectedExcel.endYear, 0);

            this.startYearOption = {
                disabledDate: (time) => {
                    return time.getTime() > end;
                }
            };
            
            if(this.selectedExcel.startYear != ''){
                var start = new Date(this.selectedExcel.startYear, 0);

                if(start > end){
                    this.selectedExcel.startYear = this.selectedExcel.endYear;
                }
            }
        },
        onSiteTypeChange(siteTypeId) {
            this.selectedSiteId = null;
            this.selectedSiteGroupId = null;
            if (siteTypeId) {
                this.filteredSites = this.sites.filter(site => {
                    return site.typeId === siteTypeId;
                });
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
        },
        multiselectSearch(searchQuery) {
            this.filteredSites = this.searchOnSites(searchQuery, this.sites);
        },
        retrieveEmissions() {
            return this.axios
                .get(
                    `/report/emission?${qs.stringify({
                        startDate: this.createUTCDate(this.year, 0, 1),
                        endDate: this.createUTCDate(this.year + 1, 0, 1),
                        emissionId: 1,
                        siteId: this.selectedSiteId,
                        groupId: this.selectedSiteGroupId
                    })}`
                )
                .then(({data}) => {
                    this.emissions = data;
                    return data;
                });
        },
        retrieveEmissionConsumptions() {
            return this.axios
                .get(
                    `/report/consumption?${qs.stringify({
                        startDate: this.createUTCDate(this.year, 0, 1),
                        endDate: this.createUTCDate(this.year + 1, 0, 1),
                        emissionId: 1,
                        siteId: this.selectedSiteId,
                        groupId: this.selectedSiteGroupId
                    })}`
                )
                .then(({data}) => {
                    this.consumptions = data;
                    return data;
                });
        },

        retrieveWasteReport() {
            return this.axios
                .get(
                    `/report/waste?${qs.stringify({
                        startDate: this.createUTCDate(this.year, 0, 1),
                        endDate: this.createUTCDate(this.year + 1, 0, 1),
                        siteId: this.selectedSiteId,
                        groupId: this.selectedSiteGroupId
                    })}`
                )
                .then(({data}) => {
                    this.waste = data;
                    return data;
                });
        },
        retrieveIntensityReport() {
            return this.axios
                .get(
                    `/report/intensity?${qs.stringify({
                        startDate: this.createUTCDate(this.year, 0, 1),
                        endDate: this.createUTCDate(this.year + 1, 0, 1),
                        emissionId: 1,
                        siteId: this.selectedSiteId,
                        groupId: this.selectedSiteGroupId
                    })}`
                )
                .then(({data}) => {
                    this.intensityReport = data;
                    this.scopeReport.current = data.currentScope;
                    this.scopeReport.past = data.pastScope;
                    this.scopeReport.scopeTags = data.scopeTags;
                    return data;
                });
        },
        selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.fetchAllData();
        },
        selectSiteGroupId(value) {
            this.selectedSiteId = null;
            if (value) {
                this.filteredSites = this.sites.filter(site => {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
        },
        fetchAllData() {
            this.$Progress.start();
            return Promise.all([
                this.retrieveEmissions(),
                this.retrieveEmissionConsumptions(),
                this.retrieveWasteReport(),
                this.retrieveIntensityReport()
            ]).then(() => {
                this.specifyComparingData(this.activeTabs.lastBox);
                this.isLoaded = true;
                this.$Progress.finish();
            });
        },
        onYearChange(newVal) {
            this.$store.state.year = newVal;
            this.$router.push({name: 'general-analysis', query: {year: this.year}});
            this.fetchAllData();
        },
        specifyComparingData(type) {
            if (type === 'consumption') {
                this.comparingData = this.consumptions.performance;
            } else if (type === 'emission') {
                this.comparingData = this.emissions.performance;
            } else if (type === 'intensity') {
                this.comparingData = [
                    this.intensityReport.performanceComparingEmissionIntensity,
                    this.intensityReport.currentStaffData
                ];
            } else {
                this.comparingData = [];
            }
        }
    },

    watch: {
        'activeTabs.lastBox': function(type) {
            this.specifyComparingData(type);
        },
        selectedSiteId() {
            this.fetchAllData();
        },
        selectedSiteGroupId() {
            this.fetchAllData();
        }
    },

    created() {
        this.selectedSiteId = this.route.params.site_id
            ? Number(this.route.params.site_id)
            : this.selectedSiteId;
        this.filteredSites = this.sites;
        this.downloadToken = this.token.substr(7);
        this.fetchAllData();
    }
};
</script>

<style lang="scss" scoped>
.borderless {
    th {
        border-top: none;
        font-size: 1.2em;
    }
}

.card-nav {
    cursor: pointer;
    &:hover {
        color: #1c7430;
    }
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "carbonEmissionTitle": "Toplam Karbon Emisyonları",
            "carbonConsumptionTitle": "Toplam Karbon Tüketimi",
            "performanceComparison": "Performans Kıyaslaması",
            "emissionDistrubition": "Emisyon Dağılımı",
            "totalEmission": "Toplam Emisyon",
            "carbonEmissionDensity": "Karbon Emisyon Yoğunluğu",
            "monthly": "Aylık Rapor",
            "yearly": "Yıllık Rapor",
            "chooseExcel": "Lütfen bir rapor seçin",
            "exportData": "Rapor Oluştur",
            "Emissions Breakdown": "Emisyon Dağılımı",
            "allLocations": "Tüm Lokasyonlar",
            "regions": "Bölgeler",
            "locationTypes": "Lokasyon Tipleri",
            "startDate": "Başlangıç",
            "endDate": "Bitiş",
            "totalGHGReport": "Toplam GHG Emisyonu Raporu",
            "totalConsumptionReport": "Toplam Tüketim Raporu",
            "export": "Oluştur",
            "chooseLocation": "Lütfen bir lokasyon grubu seçin"
        },
        "en": {
            "carbonEmissionTitle": "Total Carbon Emissions",
            "carbonConsumptionTitle": "Total Carbon Consumption",
            "performanceComparison": "Performance Comparison",
            "emissionDistrubition": "Emissions Distribution",
            "totalEmission": "Total Emissions",
            "carbonEmissionDensity": "Carbon Emissions Density",
            "monthly": "Monthly Report",
            "yearly": "Yearly Report",
            "chooseExcel": "Please choose a report",
            "exportData": "Create Report",
            "Emissions Breakdown": "Emissions Breakdown",
            "allLocations": "All Locations",
            "regions": "Regions",
            "locationTypes": "Location Types",
            "startDate": "Start Date",
            "endDate": "End Date",
            "totalGHGReport": "Total GHG Emissions Report",
            "totalConsumptionReport": "Total Consumption Report",
            "export": "Export",
            "chooseLocation": "Please select a location group"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Analysis/Tabs/AnalyzeGeneral.vue